<template>
  <div class="GlobalTable">
    <div class="button_top">
      <div class="radiobtn">
        <div class="faultBtn">
          <div :class="auditStatus === '00' ? 'active' : 'none'" @click="btnClick('00')">
            全部({{ numView.allNum || 0 }}台)
          </div>
          <div :class="auditStatus === '01' ? 'active' : 'none'" @click="btnClick('01')">
            待付款({{ numView.waitPayNum || 0 }}台)
          </div>
          <div :class="auditStatus === '02' ? 'active' : 'none'" @click="btnClick('02')">
            待收货({{ numView.waitTakeDeliveryNum || 0 }}台)
          </div>
          <div :class="auditStatus === '03' ? 'active' : 'none'" @click="btnClick('03')">
            已完成({{ numView.finishNum || 0 }}台)
          </div>
          <div :class="auditStatus === '20' ? 'active' : 'none'" @click="btnClick('20')">
            已取消({{ numView.cancelNum || 0 }}台)
          </div>
        </div>
      </div>
    </div>
    <div v-if="seachDataList.length">
      <div v-for="(item, index) in seachDataList" style="margin-bottom: 20px" :key="item.customerOrderNo">
        <div class="table_title">
          <div class="table_index">
            <div>{{ index + 1 }}</div>
          </div>
          <div class="sell_storeType">
            <div>{{ item.catalog=='00'?"优品机":item.catalog=='01'?"演示机":"资源机" }}</div>
          </div>
          <div class="table_orderNo" style="margin-left: 5px;">
            <div>订单号：{{ item.sellOrderNo }}</div>
          </div>
          <div class="table_copy" @click="copyValue(item.sellOrderNo)">
            复制
          </div>
          <div class="table_storeType2">
            <div>现场付款</div>
          </div>
        </div>
        <div class="table_list">
          <el-table ref="tableGroup" :highlight-current-row="true" stripe :data="[item]" size="small" border
            style="width: 100%">
            <el-table-column prop="productCode" label="商品编号" align="center">
            </el-table-column>
            <el-table-column prop="imageList" label="旧机图片" align="center">
              <template slot-scope="{ row }">
                <img v-if="row.imageList" style="cursor: pointer;width: 60px;height: 70px;" :src="row.imageList[0].smallImg" alt=""
                  @click="staffDia(row)">
                <img v-else style="cursor: pointer;" src="http://img.fanxinghuishou.cn/20230418/075263776.png" alt="">
              </template>
            </el-table-column>
            <el-table-column prop="productName" label="旧机机型" align="center">
            </el-table-column>
            <el-table-column prop="imei" label="旧机串号" align="center">
            </el-table-column>
            <el-table-column prop="named" label="购买人" align="center">
              <template slot-scope="{ row }">
                <span>{{ row.named ? row.named + '--' : '' }}{{ row.contact ? row.contact : '' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="下单时间" align="center">
              <template slot-scope="{ row }">
                <span style="text-align: center">{{ row.orderTime||"--" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="orderPrice" label="销售价" align="center">
              <template slot-scope="{ row }">
                <span>￥{{ row.orderPrice ||"--"}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="finalPrice" label="实付金额" align="center">
              <template slot-scope="{ row }">
                <span>￥{{ row.finalPrice ||"--"}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="productCost" label="成本价" align="center">
              <template slot-scope="{ row }">
                <span>￥{{ row.productCost ||"--"}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="deliveryType" label="收货方式" align="center">
              <template slot-scope="{ row }">
                <span>{{ row.deliveryType==='01' ? '到店自提' : '送货上门' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="预约时间" align="center">
              <template slot-scope="{ row }">
                <span style="text-align: center">{{ row.arriveTimeRegion||"--" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="storeName" label="提货门店" align="center">
              <template slot-scope="{ row }">
                <span>{{ row.storeName || "--" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="state" label="订单状态" align="center">
              <template slot-scope="{ row }">
                <span>{{
                  row.state == '01' ? '待付款' : row.state == '02' ? '待收货' : row.state == '03' ? '已完成' : '已取消'
                }}</span>
                <div v-if="row.state == '20'" class="textdown" style="cursor: pointer" @click="onlineCk(row)">取消原因
                </div>
              </template>
            </el-table-column>
            <!-- 分享人 -->
            <el-table-column  label="分享人" align="center" width="100">
              <!-- 01创建人 02 总监 03门店店长 04 普通职员 -->
              <template slot-scope="{ row }">
                <div v-if="row.shareStaffName">
                  <div class="textdown" style="cursor: pointer" @click="shareClick(row)">{{ row.shareStaffName }}</div>
                  <div class="textdown" style="cursor: pointer" @click="shareClick(row)">{{ row.shareStaffPhone || '--' }}</div>
                  <el-tag effect="dark" size="mini" :type="row.shareStaffType=='01'?'warning':row.shareStaffType=='02'?'danger':''">
                    {{ row.shareStaffType=='01'?'创建人':row.shareStaffType=='02'?'总监':row.shareStaffType=='03'?'店长':'员工' }}
                  </el-tag>
                </div>
                <div v-else>
                  --
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="180">
              <template slot-scope="{ row }">
                <div class="action_style">
                  <el-button size="small" type="text" round @click="jumDetal(row)">订单详情</el-button>
                   <el-button size="small" type="text" round @click="reportDetal(row)">商品详情</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div v-else class="emptyStyle">
      暂无订单~
    </div>
    <div class="orderPagina">
      <el-pagination background :current-page="page.pageNum" :page-size="page.pageSize"
        layout="total, prev, pager, next,jumper" :total="page.total" class="el-pagination-c"
        @current-change="handleCurrentChange" />
    </div>
    <!-- 取消原因 -->
    <el-dialog title="取消原因" :visible.sync="customerInfoShow" :close-on-click-modal="false" width="500px">
      <div style="font-size:14px;color:#333333;padding-bottom:21px">
        <div class="flex" style="margin-bottom:20px">
          <span>取消类型：</span><span style="color:#666666;">{{ pageShowInfo.cancelType === '01' ? "用户主动取消" : pageShowInfo.cancelType === '02' ? "店员取消" : "超时自动取消" }}</span>
        </div>
        <div class="flex" style="margin-bottom:20px" v-if="pageShowInfo.cancelType !== '01'">
          <span>操作人：</span><span style="color:#666666;">{{ pageShowInfo.cancelStaffName }}-{{ pageShowInfo.cancelStaffMobile||"--" }}</span>
        </div>
        <!-- <div class="flex" style="margin-bottom:20px" v-if="pageShowInfo.cancelType === '03'">
          <span>取消时间：</span><span style="color:#666666;">{{ pageShowInfo.autoTimeoutCancelTime }}</span>
        </div> -->
        <div class="flex" style="margin-bottom:20px">
          <span>取消时间：</span><span style="color:#666666;">{{ pageShowInfo.cancelTime }}</span>
        </div>
        <div class="flex" style="margin-bottom:20px">
          <p style="min-width: 70px;">取消原因：</p><span style="color:#666666;">{{ pageShowInfo.cancelRemark }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click.native="customerInfoShow = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 分享详情 -->
    <el-dialog title="分享详情" :visible.sync="shareDetailShow" :close-on-click-modal="false" width="500px">
      <div style="font-size:14px;color:#333333;padding-bottom:21px">
        <div class="flex" style="margin-bottom:20px">
          <span>分享人：</span><span style="color:#666666;">{{shareObj.shareStaffName}}-{{ shareObj.shareStaffPhone || '--' }}</span>
        </div>
        <div class="flex" style="margin-bottom:20px">
          <span>所在门店：</span><span style="color:#666666;">{{shareObj.shareStoreName || '--'}}</span>
        </div>
        <div class="flex" style="margin-bottom:20px">
          <span>查看商品时间：</span><span style="color:#666666;">{{shareObj.shareLookTime || '--'}}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click.native="shareDetailShow = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :width="`${800}px`" title="查看旧机图片" :visible="imgShow" @close="imgClose"
      top="5%">
      <div class="img-box">
        <div class="img-tips-box">
          <div class="img-tips" :class="imgShowOnly ? 'img-tips-choose' : 'img-tips-default'">
            旧机图片
          </div>
        </div>
        <div class="img-show">
          <div class="imgs-num" v-if="DialogImgList.length > 0">
            {{ imgShowIndex + 1 }}/{{ DialogImgList.length }}
          </div>
          <div class="block">
            <viewer :images="DialogImgList">
              <el-carousel trigger="click" height="80vh" @change="getindex">
                <el-carousel-item v-for="(item, index) in DialogImgList" :key="index">
                  <div class="sec_img">
                    <img :src="item.originalImg" alt="" />
                  </div>
                </el-carousel-item>
              </el-carousel>
            </viewer>
          </div>
          <!-- <LookImg :images="imgList"/> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import { orderList, findOrderDetail, cancelDetail, orderNoteList, orderAddNote } from "@/utils/request/newIndex";

export default {
  name: "Table",
  data() {
    return {
      // 分享人
      shareDetailShow:false,
      shareObj:{},
      auditStatus: '00',
      numView: {
        allNum: 0,
        waitPayNum: 0,
        waitTakeDeliveryNum: 0,
        finishNum: 0,
        cancelNum: 0,
      },
      page2: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      remarkListLoading: false,
      // 取消原因
      cancelDialog: false,
      customerInfoShow:false,
      cancleData: {
        notCanSellItem: []
      },
      tableColumns3: [
        { label: "更新时间", prop: "time" },
        { slotName: "description" },
      ],
      errDAta: [],
      nonsalableVisible: false,//查看不可售卖项
      // *********************
      //预估价明细信息
      estimatedRecyclePrice: 0,
      totalServePee: 0,
      serveQualityPrice: 0,
      serveAsPrice: 0,
      serveOtherPrice: 0,
      estimatedRecyclePriceAfter: 0,
      // *********
      estiPriceDialog: false,//预估价明细弹框
      seachDataList: [],
      dialogVisible: false,
      imgShow: false,
      imgShowOnly: true,
      DialogImgList: [],
      imgShowIndex: 0,
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      delDialogVisible: false,
      commentId: "",
      CancelCauseText: "",
      refundTimeDialog: false,
      refundTimeText: "",
      bagListShow: false,
      bagListloading: false,
      bagListColumns: [
        { label: "赠品名称", prop: "giftName" },
        { slotName: "giftType" },
        { slotName: "giftPrice" },
        { slotName: "giveType" },
      ],
      bagList: [],
      giftOrder: {},
      pageShowInfo:{},
    };
  },
  created() {
    this.handleCurrentChange();
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal);
      this.page.pageNum = 1;
      this.handleCurrentChange();
    },
    "modelform.merchantId"(val) {
      if (!val) {
        this.modelform.companyId = "";
      }
    },
  },
  methods: {
    //状态切换
    btnClick(type) {
      this.auditStatus = type
      this.page.pageNum = 1
      this.handleCurrentChange()
    },
    // 已取消--取消原因
    onlineCk(row) {
      console.log(row);
      this.customerInfoShow=true;
       // 详情
      _api.premiumInfo({ sellOrderNo: row.sellOrderNo }).then(res => {
        this.pageShowInfo = res.data
      })
     
    },
    // 分享详情
    shareClick(row){
      console.log(row);
      this.shareObj=row;
      this.shareDetailShow=true;
      // console.log(this.shareObj,'shareObj');
    },
    //
    getindex(e) {
      console.log(e);
      this.imgShowIndex = e;
    },
    //订单详情
    jumDetal(row) {
      console.log(row,"123");
      let lybl = this.$router.resolve(
        {
          path: '/onlinSalemachines/Saleorderdetails',
          query: {
            sellOrderNo: row.sellOrderNo
          }
        })

      window.open(lybl.href, '_blank');
    },
    //商品详情
    reportDetal(row) {
      let lybl = this.$router.resolve(
        {
          path: '/onlinSalemachines/productList',
          query: {
            productCode: row.productCode
          }
        })

      window.open(lybl.href, '_blank');
    },
    //查看图片
    staffDia(row) {
      if (row.imageList) {
        this.imgShow = true;
        this.DialogImgList = row.imageList;
        console.log(this.DialogImgList);
      }
    },
    imgClose() {
      console.log(1);
      this.imgShow = false;
      this.imgList = [];
    },
    // 复制
    copyValue(context) {
      // 创建输入框元素
      let oInput = document.createElement("input");
      // 将想要复制的值
      oInput.value = context;
      // 页面底部追加输入框
      document.body.appendChild(oInput);
      // 选中输入框
      oInput.select();
      // 执行浏览器复制命令
      document.execCommand("Copy");
      // 弹出复制成功信息
      this.$message.success("复制成功");
      // 复制后移除输入框
      oInput.remove();
    },
    // 表格切换页面
    handleCurrentChange(val) {
      console.log("表格切换页面", val);
      if (val) {
        this.page.pageNum = val;
      } else {
        this.page.pageNum = 1;
      }
      const params = {
        state:this.auditStatus,
        storeId: this.SeachParams.storeId,
        sellOrderNo: this.SeachParams.sellOrderNo,
        userPhone: this.SeachParams.userPhone,
        catalog: this.SeachParams.catalog,
        startTime: this.SeachParams.startTime,
        endTime: this.SeachParams.endTime,
        imei: this.SeachParams.imei,
        deliveryType: this.SeachParams.deliveryType,
        productCode: this.SeachParams.productCode,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      this.loading = true;
      _api.excellentList(params).then((res) => {
        if (res.code === 1) {
          this.seachDataList = res.data.page.records;
          this.page.total = res.data.page.total;
          this.page.pageNum = res.data.page.current;
          this.numView.allNum = res.data.allNum
          this.numView.waitPayNum = res.data.waitPayNum
          this.numView.waitTakeDeliveryNum = res.data.waitTakeDeliveryNum
          this.numView.finishNum = res.data.finishNum
          this.numView.cancelNum = res.data.cancelNum
          this.loading = false;
        }
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
        this.loading = false;
      }).catch(() => {
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">

.action_style{
  display: flex;
  align-items: center;
/deep/.el-button {
    text-decoration: underline;
    margin: 0;
}
}
.emptyStyle {
  width: 100%;
  text-align: center;
  padding: 80px 0;
  font-size: 24px;
  color: #666666;
  background: white;
  font-weight: bold;
}

.button_top {
  margin-bottom: 20px;
  ;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.faultBtn {
  min-width: 500px;
  height: 34px;
  background: #F9FBFD;
  border: 1px solid #C1D1FF;
  box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
  border-radius: 21px;
  display: flex;
  cursor: pointer;

  .active {
    text-align: center;
    color: white;
    // width: 50%;
    height: 14px;
    padding: 0 15px;
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    line-height: 32px;
    height: 32px;
    background: #0981FF;
    border-radius: 20px;
  }

  .none {
    text-align: center;
    color: #333;
    // width: 50%;
    padding: 0 15px;
    height: 14px;
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    line-height: 32px;
    height: 32px;
    border-radius: 20px;
  }
}

.color1 {
  color: #0981FF;
}

.color2 {
  color: #F83232;
}

.type03 {
  margin-top: 6px;
  color: #999;
  padding: 8px;
  border-radius: 4px;
  background-color: #F2F2F2;
}

.exStitle {
  margin-bottom: 15px;
  color: #ff8080;
  font-size: 14px;
}

.enable_tip {
  width: 460px;
  display: flex;
  flex-wrap: wrap;

  >div {
    width: 210px;
    margin: 0 20px 20px 0;
    font-weight: bold;
  }

}

.cblue {
  color: #0981FF;
}

.est_box {
  padding-left: 20px;
}

.middle_box {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #eee;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  border-radius: 4px;
}

.fzs16 {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  text-align: center;
}

.fzs14 {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
}

.non-sales-item {
  width: 340px;
  // height: 40px;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 6px;
  background-color: #F2F2F2;
  color: #F83232;
}

.mb10 {
  margin-bottom: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.mb30 {
  margin-bottom: 30px;
}

.texleft {
  text-align: left;
}

.tableBtnUn {
  color: #0981ff;
  cursor: pointer;
  text-decoration: underline;
}

.colocah {
  text-align: center;
  color: #0981ff;
}

.img-box {
  margin-bottom: 20px;

  // 图片
  .imgs-num {
    text-align: center;
    margin: 5px 0;
    font-weight: bold;
  }

  .img-tips-box {
    display: flex;
    height: 30px;
    width: max-content;
    border: 1px solid #0981ff;

    .img-tips {
      width: 80px;
      text-align: center;
      line-height: 30px;
      box-sizing: border-box;
      cursor: pointer;
    }

    .img-tips-default {
      background: #fff;
      color: #0981ff;
    }

    .img-tips-choose {
      background: #0981ff;
      color: #fff;
    }
  }

  .sec_img {
    width: 20vw;
    height: 80vh;
    margin: auto;

    img {
      width: 20vw;
      height: 80vh;
      object-fit: contain;
    }
  }

  // 列表
}

.GlobalTable {

  // 查看明细详情
  .settlement_detail {
    width: 100%;

    >h2 {
      font-size: 14px;
      color: #308BFB;
      margin-bottom: 20px;
      font-weight: 900;
    }

    >div {
      width: 100%;
      background: #f5f6fa;
      border-radius: 6px;
      padding: 12px;
      box-sizing: border-box;
      margin-bottom: 20px;

      >h3 {
        font-size: 14px;
        color: #2384FB;
        padding-left: 12px;
        line-height: 14px;
        position: relative;

        &::after {
          content: "";
          background: #2384FC;
          display: block;
          position: absolute;
          left: 0;
          top: 1px;
          width: 4px;
          border-radius: 2px;
          height: 12px;
        }
      }

      >div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
        padding-left: 10px;

        >p:first-of-type {
          color: #F80000;
        }
      }
    }
  }

  .table_title {
    position: relative;
    display: flex;
    height: 40px;
    padding: 10px 0;
    align-items: center;
    background: #F4F6F9;
    border-radius: 6px 6px 0px 0px;
  }

  .table_index {
    background: #fcba05;
    height: 20px;
    padding: 0 10px;
    color: #fff;
    text-align: center;
    line-height: 20px;
    border-radius: 3px 10px 10px 3px;
    margin-left: -5px;
  }

  .table_storeType {
    border-radius: 10px 10px 10px 0;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgb(248, 50, 50);
    color: rgb(248, 50, 50);
    font-size: 12px;
    padding: 3px 5px;
    position: absolute;
    right: 20px;
  }

  .sell_storeType {
    margin-left: 10px;
    border-radius: 20px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgb(248, 50, 50);
    color: rgb(248, 50, 50);
    font-size: 12px;
    padding: 3px 5px;
  }

  .sell_storeType2 {
    border-radius: 10px 10px 10px 0;
    background-color: #fff;
    position: absolute;
    right: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #0981ff;
    color: #0981ff;
    font-size: 12px;
    padding: 3px 5px;
  }

  .table_storeType2 {
    border-radius: 10px 10px 10px 0;
    background-color: #fff;
    position: absolute;
    right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #0981ff;
    color: #0981ff;
    font-size: 12px;
    padding: 3px 5px;
  }

  .table_orderNo {
    // color: #0981ff;
    font-size: 14px;
    margin-left: 20px;
    padding: 0 5px;
  }

  .table_copy {
    cursor: pointer;
    color: #fff;
    text-align: center;
    line-height: 20px;
    margin-left: 10px;
    border-radius: 5px;
    font-size: 12px;
    padding: 0 5px;
    background: #0981ff;
  }

  .red {
    color: red;
  }

  .green {
    color: #00b305;
  }

  .ccc {
    color: #707070;
  }

  .mt-20 {
    margin-top: 20px;
  }

  .mb-10 {
    margin-bottom: 10px;
  }

  .mb-20 {
    margin-bottom: 20px;
  }

  .mr-50 {
    margin-right: 50px;
  }

  .ml-10 {
    margin-left: 10px;
  }

  .mr-10 {
    margin-right: 10px;
  }

  .font-w {
    font-weight: bold;
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .flex-jb {
    display: flex;
    justify-content: space-between;
  }

  .flex-as {
    display: flex;
    align-items: flex-start;
  }

  .flex-ja {
    display: flex;
    justify-content: space-around;
  }

  // 备注说明
  .Remarks {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }

  .images-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .images-box>img {
    width: 70px;
    height: 70px;
    margin-bottom: 10px;
  }

  .images-box>span {
    color: #0981ff;
    cursor: pointer;
  }

  .textdown {
    color: #0981ff;
    text-decoration: underline;
  }

  .orderPagina {
    float: right;
    margin: 50px;
  }
}
</style>
